import { LogUtil } from 'components/common/LogUtil';
import { useEffect } from 'react';
import {
  SET_REFRESH_RECEIVER_LIST,
  SET_REFRESH_TRANSACTION_LIST,
} from 'store/action';
import usePage from './usePage';
import useStore from './useStore';

const stateStoreDefault = {
  refreshReceiverList: null,
  refreshTransactionsList: true,
};

const usePageCleanUp = () => {
  const { dispatch } = useStore();
  const { isReceiversPage, isTransactionsPage, isFxTransactionsPage } =
    usePage();

  useEffect(() => {
    return () => {
      if (!isReceiversPage) return;
      LogUtil.log('usePageCleanUp', 'ReceiversPage XXXX CLEANUP');
      dispatch({
        type: SET_REFRESH_RECEIVER_LIST,
        payload: stateStoreDefault.refreshReceiverList,
      });
    };
  }, [isReceiversPage]);

  useEffect(() => {
    return () => {
      if (!isTransactionsPage) return;
      LogUtil.log('usePageCleanUp', 'TransactionsPage XXXX CLEANUP');
      dispatch({
        type: SET_REFRESH_TRANSACTION_LIST,
        payload: stateStoreDefault.refreshTransactionsList,
      });
    };
  }, [isTransactionsPage]);

  useEffect(() => {
    return () => {
      if (!isFxTransactionsPage) return;
      LogUtil.log('usePageCleanUp', 'FxTransactionsPage XXXX CLEANUP');
      dispatch({
        type: SET_REFRESH_TRANSACTION_LIST,
        payload: stateStoreDefault.refreshTransactionsList,
      });
    };
  }, [isFxTransactionsPage]);
};

export default usePageCleanUp;
